import newhttp from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    page: 1,
    pages: 0,
  },

  getters: {
    requestData(state, getters, rootState, rootGetters) {
      const { filters, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        fromDate: filters.fromDate ? filters.fromDate : undefined,
        toDate: filters.toDate ? filters.toDate : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const response = await newhttp.get('v1/p2p/get-requisites-statistics', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });

      const { rows, totalCount } = response.data;

      commit('SET_DATA', rows);
      if (totalCount) {
        const itemsPerPage = rootGetters['common/itemsPerPage'];
        const pages = Math.ceil(totalCount / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },
  },

  namespaced: true,
});
